import { HalfMoonFilled } from "./SVG"; 
export default (config = {}) => { 
    
Log('Found Icons', config.iconLight, config.iconDark);
    return `<div class="_track wp-dark-mode-ignore"><div class="_icon wp-dark-mode-ignore">${config.iconLight || HalfMoonFilled}</div><div class="_icon wp-dark-mode-ignore">${config.iconDark || HalfMoonFilled}</div></div>` }